const notificaionInitialState = {
    notificaciones: {
        data: false, 
        loading: false, 
        error: false, 
        idTurno: false    
    }
};
  
  export default notificaionInitialState;